export const CRIMES_INQUIRY = 'CRIMES_INQUIRY';

export const setCrimeInquiryReducer = crimes => ({
  type: CRIMES_INQUIRY,
  payload: crimes,
});
